module.exports = __webpack_public_path__ + "static/media/cross.6e26eabf.svg";